var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[(_vm.isMobile && !_vm.$store.state.app.ignoreUnsupportedDevices)?_c('unsupported-device'):_c(_vm.layout,{tag:"component",attrs:{"widget_id":_vm.widget_id,"national_id":_vm.national_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }